import React, {useEffect, useState} from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import {Col} from "react-bootstrap";
import FeatherIcon from "feather-icons-react";
import {useHistory, useParams} from "react-router-dom";
import {
    changeView,
    resetConfirmationDialog,
    toggleConfirmationDialog,
    toggleLoader
} from "../../shared/actions/setting";
import axios from "axios";
import {getUserId} from "../../shared/authentication/authentication";
import {toast} from "react-toastify";
import {useDispatch, useSelector} from "react-redux";
import FormHandler from "../../shared/util/form-handler";
import {validateMachineSubmit} from "../../shared/authentication/form-validation-rules";
import MachineItem from "./machine-item";
import * as _ from "underscore";
import {VIEW} from "../../shared/util/enum";
import {isEmpty} from "../../shared/util/utils";
import {getSelectedDepartment} from "../../actions/department";
import {TYPE} from "../../shared/util/enum";
import EmployeeCard from "../../layouts/employee-card";

const MachineList = (props) => {
    const {departmentID} = useParams();
    let history = useHistory();
    const [machineList, setMachineList] = useState([]);
    const [suggestionList,setSuggestionList]=useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdateAvailable, setIsUpdateAvailable] = useState(false);
    const [formErr, setFormErr] = useState(null);
    const [isAddMachine, setIsAddMachine] = useState(false);
    const dispatch = useDispatch();
    const [multiMembers, setMultiMembers] = useState([]);
    const [deleteId, setDeleteId] = useState("");
    const [machineId, setMachineId] = useState("");
    const [updateIndex,setUpdateIndex] = useState([]);
    const [isViewEmployees,setIsViewEmployee] = useState(false);
    const [selectedEmployees,setSelectedEmployees] = useState([]);
    const [selectedMachine, setSelectedMachine] = useState('');
    const selectedDept = useSelector(state => {
        return state.department.selectedDepartment;
    });
    const confirmationDialog = useSelector(state => {
        return state.setting.confirmationDialog
    });
    const department = useSelector(state => {
        return state.department.department;
    });

    const {
        values,
        errors,
        handleChange,
        handleSubmit,
        handleOnBlur,
        initForm,
        deleteErrors,
    } = FormHandler(machine, validateMachineSubmit);

    useEffect(() => {
        dispatch(changeView(VIEW.MACHINE_LIST));
    }, []);

    useEffect(() => {
        if (!isEmpty(selectedDept)) {
            return;
        }

        dispatch(toggleLoader(true));
        axios.get(process.env.REACT_APP_HOST + 'user/'
          + getUserId() + '/department/'+ departmentID )
          .then(res => {
              dispatch(getSelectedDepartment(res.data.content));
          }).catch(error => {
              if (error.response.status === 422) {
                  toast.error(error.response.data.message);
              }
          }
        ).finally(() => {
            dispatch(toggleLoader(false))
        })
    }, [selectedDept]);

    useEffect(() => {
        if (!isLoading) {
            return;
        }

        if (!isUpdateAvailable) {
            values.departmentId = departmentID;
            console.log(values.type)
            // values.trainedEmployees = multiMembers;
            values.trainedEmployees = _.pluck(multiMembers, 'id');
            console.log(values.trainedEmployees)
            dispatch(toggleLoader(true));
            axios.post(process.env.REACT_APP_HOST + `user/` + getUserId() + '/machine', values)
                .then(res => {
                    setIsAddMachine(false);
                    setMachineList(oldArray => [ ...oldArray,res.data.content]);
                    toast.success("Machine created successfully");
                    resetForm();
                })
                .catch(error => {
                        if (error.response && error.response.status === 422) {
                            setFormErr(error.response.data.message);
                        }
                        console.log(error);
                    }
                )
                .finally(() => {
                    setIsLoading(false);
                    dispatch(toggleLoader(false));
                });
        }
        else {
            values.corporateId = "60a7794ef812231385f6dce0";
            values.departmentId = departmentID;
            values.trainedEmployees = _.pluck(multiMembers, 'id');
            dispatch(toggleLoader(true));
            axios.put(process.env.REACT_APP_HOST + `user/` + getUserId() + '/machine/' + values.id, delete values.index && delete values.id && values)
                .then(res => {
                    setIsAddMachine(false);
                    machineList[updateIndex] = res.data.content;
                    setMachineList(machineList);
                    toast.success("Machine updated successfully");
                    resetForm();
                })
                .catch(error => {
                    if (error.response && error.response.status === 422) {
                        setFormErr(error.response.data.message);
                    }
                })
                .finally(() => {
                    setIsLoading(false);
                    dispatch(toggleLoader(false));
                });
        }

    }, [isLoading]);

    useEffect(() => {
        dispatch(toggleLoader(true));
        axios.get(process.env.REACT_APP_HOST + 'user/'
            + getUserId() + '/department/'+ departmentID +'/machine' )
            .then(res => {
                setMachineList(res.data.content);
            }).catch(error => {
                if (error.response.status === 422) {
                    toast.error(error.response.data.message);
                }
            }
        ).finally(() => {
            dispatch(toggleLoader(false))
        })

    }, [departmentID]);

    useEffect(() => {
        if (!confirmationDialog || !confirmationDialog.onSuccess) {
            return;
        }
        console.log(deleteId)
        dispatch(resetConfirmationDialog());
        dispatch(toggleLoader(true));
        axios.delete(process.env.REACT_APP_HOST + `user/` + getUserId() + '/machine/' + deleteId)
            .then(res => {
                setMachineList(machineList.filter(item => item.id !== deleteId));
                toast.success("Machine deleted successfully");
                dispatch(toggleLoader(false));
            }).catch(error => {
            dispatch(toggleLoader(false));
            if (error.response && error.response.status === 422) {
                toast.warn(error.response.data.message);
            }
        })
    }, [confirmationDialog]);

    function machine() {
        setIsLoading(true);
    }

    function resetForm() {
        initForm({});
        deleteErrors(errors);
        setIsUpdateAvailable(false);
        // setStartDate(new Date());
        setFormErr("");
    }

    function formClick(event) {
        let names=['suggestion','name'];
        if(!event.target.name || !names.includes(event.target.name ) ){
            suggestionList.length >0 && setSuggestionList([]);
        }
    }

    function handleDeleteMachine(id) {
        console.log(id)
        dispatch(toggleConfirmationDialog({
            isVisible: true,
            confirmationHeading: "Are you sure you want to delete this machine?",
            confirmationDescription: "The delete action will remove the machine."
        }));
        setDeleteId(id);
    }

    function setIsUpdateAvailableEdit(id,index,name,circumference,type,kitId) {
        values.id = id;
        setMachineId(id);
        values.name = name;
        values.kitId = kitId;
        values.circumference = circumference;
        values.type = type;
        setIsUpdateAvailable(true);
        setIsAddMachine(true);
        setUpdateIndex(index);
    }
    
    return (
        <div>
            <div id="listView" className={'list-view full-list-view'}>
                <div className={"half-list-container"}>
                    <Container className="m-t-8">
                        <Row className={"container-machine-list"}>
                            {machineList.length > 0 && machineList.map((machineProp, index) =>
                              <Col className={"grid-machine"} xl={4} lg={6} key={index + "machine"}>
                                  <MachineItem 
                                    machine={machineProp} 
                                    index={index} parentCallback={handleDeleteMachine} 
                                    parentCallbackEdit = {setIsUpdateAvailableEdit} 
                                    onPressViewEmployees={(machineName, value) => {
                                        setIsViewEmployee(true);
                                        setSelectedMachine(machineName);
                                        setSelectedEmployees(value);
                                    }}/>
                              </Col>
                            )}
                            {machineList.length === 0 && (
                                <div className={"empty-results"}>
                                    <FeatherIcon icon="info"/>
                                    <div className={"empty-results-text"}>There are no machines</div>
                                </div>)}
                        </Row>
                    </Container>
                </div>
            </div>
            <div>
                <div>
                    <div className="map-toggle-add-btn ">
                        <div className="container" >
                            <div className="pull-right toggle-btn" >
                                <div className="">
                                    <div className="add-btn sa-cursor">
                                        <FeatherIcon
                                            onClick={() => {
                                                resetForm();
                                                setIsAddMachine(true);
                                                values.corporateId = "60a7794ef812231385f6dce0";
                                                setMultiMembers([]);
                                            }}
                                            className={"icon-in-add-btn"} icon="plus-circle"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*-----------------------------------------------------------------Add Machine---------------------------------------------------            */}
                    {isAddMachine && <div  onClick={formClick} className="sa-modal-bg">
                        <div className="sa-modal-bg-inner">
                            <div className="sa-modal-box ">
                                <div className="container">
                                    <form onSubmit={handleSubmit} noValidate>
                                        <div className="sa-modal-header">
                                            {!isUpdateAvailable ? "Add New Machine" : "Edit Machine"}
                                            <div className="sa-modal-close" onClick={() => {
                                                setIsAddMachine(false)
                                                resetForm();
                                            }}><FeatherIcon className={"icon-in-close"} icon={"x"}/>
                                            </div>
                                        </div>
                                        <div  className="row sa-modal-content">
                                            <div className="col-md-6">
                                                <div className="form-group m-b-16">
                                                    <label>Machine Id</label>
                                                    {!isUpdateAvailable && (
                                                        <input type="text"
                                                               className={`form-control ${errors.id && "warning-input"}`}
                                                               name="id"
                                                               onChange={handleChange}
                                                               value={values.id || ""}
                                                               autoComplete={"off"}
                                                               placeholder="Enter Machine Id"/>) }
                                                    {isUpdateAvailable && (
                                                        <input type="text"
                                                               className={`form-control ${errors.id && "warning-input"}`}
                                                               name="id"
                                                               onChange={handleChange}
                                                               value={values.id || ""}
                                                               autoComplete={"off"}
                                                               disabled
                                                               placeholder="Enter Machine Idsdd"/> )
                                                    }

                                                </div>
                                                {errors.id && (
                                                    <p className="warning-input-msg">{errors.id}</p>)
                                                }
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group m-b-16">
                                                    <label>Machine Name</label>
                                                    <input type="text"
                                                           className={`form-control ${errors.name && "warning-input"}`}
                                                           name="name"
                                                           onChange={handleChange}
                                                           value={values.name || ""}
                                                           autoComplete={"off"}
                                                           placeholder="Enter Machine Name"/>

                                                </div>
                                                {errors.name && (
                                                    <p className="warning-input-msg">{errors.name}</p>)
                                                }
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group m-b-16">
                                                    <label>Machine Type</label>
                                                    <select className={`form-control ${errors.type && "warning-input"}`}
                                                        name="type"
                                                        onBlur={handleOnBlur} onChange={handleChange}
                                                        value={values.type || ""}>
                                                        <option hidden value={""}>Select a Type</option>
                                                        {
                                                            department && department.map((item,index) =>{
                                                                return <option key={index} value={item.name}>{item.name}</option>
                                                            })
                                                        }
                                                    </select>

                                                </div>
                                                {errors.type && (
                                                    <p className="warning-input-msg">{errors.type}</p>)
                                                }
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group m-b-16">
                                                    <label>Kit ID</label>
                                                    <input type="text"
                                                           className={`form-control ${errors.kitId && "warning-input"}`}
                                                           name="kitId"
                                                           onChange={handleChange}
                                                           value={values.kitId || ""}
                                                           autoComplete={"off"}
                                                           placeholder="Enter Kit ID"/>
                                                </div>
                                                {errors.kitId && (
                                                    <p className="warning-input-msg">{errors.kitId}</p>)
                                                }
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group m-b-16">
                                                    <label>Circumference</label>
                                                    <input type="text"
                                                           className={`form-control ${errors.circumference && "warning-input"}`}
                                                           name="circumference"
                                                           onChange={handleChange}
                                                           value={values.circumference || ""}
                                                           autoComplete={"off"}
                                                           placeholder="Enter Circumference"/>
                                                </div>
                                                {errors.circumference && (
                                                    <p className="warning-input-msg">{errors.circumference}</p>)
                                                }
                                            </div>
                                        </div>
                                        <div className="sa-modal-footer">
                                            {formErr && 
                                                <div>
                                                    <div id={"formErr"} className={"login-warning-msg font-size-14"}>Failed!</div>
                                                    <div id={"formErr"} className={"login-warning-msg font-size-14 mt-1"}>{formErr}</div>
                                                </div>
                                            }
                                            <div>
                                                <div className="sa-modal-footer-btn">
                                                    <button id="btnCancel" type={"button"} className="btn btn-sa-text btn-sa-text-size btn-sa-width" onClick={() => {
                                                        setIsAddMachine(false);
                                                    }}>CANCEL
                                                    </button>
                                                    <button id="btnAdd" className="btn btn-sa-primary-factoryspy btn-sa-width">
                                                        {!isUpdateAvailable ? "ADD" : "UPDATE"}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>}
                    {/*-----------------------------------------------------------------View Machine Employees---------------------------------------------------            */}
                    {isViewEmployees && <div className="sa-modal-bg">
                        <div className="sa-modal-bg-inner">
                            <div className="employee-modal-box">
                                <div className="sa-modal-header">
                                    <label className="font-size-18">{selectedMachine && `${selectedMachine} Employee Details`}</label>
                                    <div className="sa-modal-close" onClick={() => {
                                        setIsViewEmployee(false);
                                        setSelectedEmployees([]);
                                    }}>
                                        <FeatherIcon className={"icon-in-close"} icon={"x"}/>
                                    </div>
                                </div>
                                <div className="sa-modal-content">
                                    <Row xs={1} md={2} className="g-4">
                                        {selectedEmployees && selectedEmployees.filter(item => item && item.employee).map((item, idx) => (
                                            <Col key={idx} className="mt-2">
                                                {/* Job-based performance; missing until the employee has recorded work time */}
                                                <EmployeeCard name={item.employee.name} employeeID={item.employee.empId} percentage={item.performance?.overallPerformance} image={item.employee.imageUrl}/>
                                            </Col>
                                        ))}
                                    </Row>
                                </div>
                            </div>
                        </div>
                    </div>}
                </div>
            </div>
        </div>
    )
};

export default MachineList;